import {
    apiRequest,
    kursusCreate
} from "../../../../../../services/adapters/kepegawaian/kursusService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", kursusCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository